"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var hook_use_bem_classes_1 = __importDefault(require("@rotaryintl/hook-use-bem-classes"));
var classnames_1 = __importDefault(require("classnames"));
require("./divider.styles.css");
var bem = (0, hook_use_bem_classes_1.default)('rwc-divider');
var Divider = function (_a) {
    var _b = _a.color, color = _b === void 0 ? 'gold' : _b, _c = _a.thickness, thickness = _c === void 0 ? 'thin' : _c;
    var classes = (0, classnames_1.default)(bem(), bem('', thickness), bem('', color));
    return (0, jsx_runtime_1.jsx)("hr", { className: classes });
};
exports.default = Divider;
//# sourceMappingURL=divider.component.js.map